import { ConverterType } from '../domain';
export const pageUrlV2 = {
    types: ['wix.common.PageUrlV2'],
    [ConverterType.FROM_JSON]: {
        transform: (val) => {
            if (!val) {
                return;
            }
            return val.url;
        },
    },
    [ConverterType.TO_JSON]: {
        transform: (val) => {
            if (!val) {
                return;
            }
            const { pathname } = new URL(val);
            return {
                relativePath: pathname,
                url: val, // (e.g https://mysite.com/product-page/a-product)
            };
        },
    },
};
//# sourceMappingURL=page-url-v2.js.map